import React, { useState, useEffect, createContext, useContext } from 'react';
import { getBaseURL } from '../Utility/getBaseURL'

export const AuthContext = createContext({
	testlogin: null,
	nonce: null,
	setLogin: () => {}
});


export default function AuthProvider({children}) {
	const [login, setLogin] = useState(false);
	const [user, setUser] = useState(null);
	const [nonce, setNonce] = useState(null);

	useEffect(() => {
	    async function fetchNonce() {
		    const url = getBaseURL() + '/wp-admin/admin-ajax.php?action=rest_nonce';
			await fetch(url, {
				method:'post', 
				credentials:'include'
			} )
			.then(async response => {
				const data = await response.json();
				if(data.user.ID > 0) {
					setLogin(true);
				}
				setUser(data.user);
				setNonce(data.nonce);
		  	})
			.catch( e => {
				throw(e);
			});
	    }
	    fetchNonce();
	}, [])
	const value = { login, user, nonce }
	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export function useAuth() {
	const context = useContext(AuthContext);
	if (context === undefined) {
		throw new Error("Context must be used within a Provider");
	}
	return context;
}